export const networkList=['未知', '宽带', 'Wi-Fi', '2G', '3G', '4G', '5G']

export const addTestText={
  'game':{
    unit:'ms',
    title:'游戏测速',
    toolName:'game-add',
    ping:[
      '0~50ms',
      '50~100ms',
      '100~200ms',
      '大于200ms'
    ],
    rate:[
      '极好',
      '良好',
      '一般',
      '极差',
    ],
    text:[
      '你的网速太棒了，助你游戏轻松上分，五杀不是梦',
      '你的网速处于正常水平，无明显时延，不坑队友',
      '你的网速略有时延，游戏过程中偶尔可能感觉到卡顿',
      '你的网速太慢咯，进入游戏会卡顿，可能会有掉线情况'
    ]
  },
  'live':{
    unit:'ms',
    title:'直播测速',
    toolName:'live-add',
    ping:[
      '0~50ms',
      '50~100ms',
      '100~200ms',
      '大于200ms'
    ],
    rate:[
      '极好',
      '良好',
      '一般',
      '极差',
    ],
    text:[
      '畅享1080P高清画质直播，直播流畅，声音音质清晰',
      '推荐进行720P普通画质直播，直播不卡顿，声音音质清晰',
      '建议进行360P及以下一般画质直播，直播偶尔会掉帧，声音音质模糊',
      '建议暂停直播，会经常卡顿和掉线，影响直播效果'
    ]
  },
  'video':{
    unit:'ms',
    title:'视频测速',
    toolName:'video-add',
    ping:[
      '0~50ms',
      '50~100ms',
      '100~200ms',
      '大于200ms'
    ],
    rate:[
      '极好',
      '良好',
      '一般',
      '极差',
    ],
    text:[
      '畅享1080P高清画质视频，视频流畅，声音音质佳',
      '建议切换至720P普通画质视频，视频不卡顿，声音音质好',
      '建议切换至360P及以下一般画质视频，视频偶尔会掉帧，声音音质较差',
      '已经无法正常播放视频了，建议提升宽带网速'
    ]
  },
  'mall':{
    unit:'ms',
    title:'电商测速',
    toolName:'mall-add',
    ping:[
      '0~50ms',
      '50~100ms',
      '100~200ms',
      '大于200ms'
    ],
    rate:[
      '极好',
      '良好',
      '一般',
      '极差',
    ],
    text:[
      '网络很好，电商网页秒开，极速的购物体验',
      '网络良好，可以正常的打开电商网页，畅享购物',
      '网络一般，电商网页加载缓慢',
      '网络开小差了，打开电商网页无法显示任何元素'
    ]
  },
  'ticket':{
    unit:'ms',
    title:'购票测速',
    toolName:'ticket-add',
    ping:[
      '0~50ms',
      '50~100ms',
      '100~200ms',
      '大于200ms'
    ],
    rate:[
      '极好',
      '良好',
      '一般',
      '极差',
    ],
    text:[
      '不只是运气，更多的是实力',
      '眼疾手快，只为弯道超“速”',
      '不期待速度最快，只求运气最好',
      '网速有待提升，距离购票成功仅一步之遥'
    ]
  },
  'news':{
    unit:'ms',
    title:'资讯测速',
    toolName:'news-add',
    ping:[
      '0~50ms',
      '50~100ms',
      '100~200ms',
      '大于200ms'
    ],
    rate:[
      '极好',
      '良好',
      '一般',
      '极差',
    ],
    text:[
      '几乎察觉不出有时延，打开网页都特别顺畅',
      '可以正常打开网页，没有明显的时延情况',
      '显示资讯页面，偶尔会感觉加载缓慢',
      '已出现断网或无法打开资讯页面'
    ]
  },
  'search':{
    unit:'ms',
    title:'搜索测速',
    toolName:'search-add',
    ping:[
      '0~50ms',
      '50~100ms',
      '100~200ms',
      '大于200ms'
    ],
    rate:[
      '极好',
      '良好',
      '一般',
      '极差',
    ],
    text:[
      '几乎察觉不出有时延，搜索结果秒开',
      '可以正常搜索相关内容，没有明显的时延情况',
      '显示搜索结果，需要有较长的加载时间',
      '已出现断网或无法打开搜索页面'
    ]
  },
  'red-packet':{
    unit:'ms',
    title:'抢红包测速',
    toolName:'red-packet-add',
    ping:[
      '0~50ms',
      '50~100ms',
      '100~200ms',
      '大于200ms'
    ],
    rate:[
      '极好',
      '良好',
      '一般',
      '极差',
    ],
    text:[
      '不只是运气，更多的是实力',
      '眼疾手快，只为弯道超“速”',
      '不期待速度最快，只求运气最好',
      '眼看红包从你手边溜走'
    ]
  },
  'web':{
    unit:'s',
    title:'网页打开速度',
    toolName:'web-add',
    ping:[
      '小于等于1s',
      '小于等于2s，大于1s',
      '大于2s，小于等于6s',
      '大于6秒'
    ],
    rate:[
      '很快',
      '正常',
      '较慢',
      '极慢',
    ],
    text:[
      '哦呜，你打开网页速度太慢，将会影响你的上网体验',
      '你打开网页速度较慢，需要你耐心等候',
      '你打开网页速度正常，和大部分小伙伴速度一致',
      '哇塞，你打开网页秒开，可以畅享上网冲浪的自由感觉'
    ]
  },
  'webclass':{
    unit:'ms',
    title:'上网课测速',
    toolName:'webclass-add',
    ping:[
      '0~50ms',
      '50~100ms',
      '100~200ms',
      '大于200ms'
    ],
    rate:[
      '极好',
      '良好',
      '一般',
      '极差',
    ],
    text:[
      '学习好，更多的是实力',
      '网课不卡顿，上课有保障',
      '网课清晰度不高、卡顿变多',
      '上网质量不佳，可能会影响上课体验'
    ]
  },
  'cloudgame':{
    unit:'ms',
    title:'云游戏测速',
    toolName:'cloudgame-add',
    ping:[
      '0~50ms',
      '50~100ms',
      '100~200ms',
      '大于200ms'
    ],
    rate:[
      '极好',
      '良好',
      '一般',
      '极差',
    ],
    text:[
      '你的网速太棒了，助你游戏轻松升级打怪爆装备',
      '你的网速处于正常水平，无明显时延，不坑队友',
      '你的网速略有时延，游戏过程中偶尔可能感觉到卡顿',
      '你的网速太慢咯，进入游戏会卡顿，可能会有掉线情况'
    ]
  },
}

export const industryList=[
  {
    label:"智能交通",
    value:"智能交通"
  },
  {
    label:"车辆监控",
    value:"车辆监控"
  },
  {
    label:"安防监控",
    value:"安防监控"
  },
  {
    label:"工业监控",
    value:"工业监控"
  },
  {
    label:"金融行业",
    value:"金融行业"
  },
  {
    label:"电力行业",
    value:"电力行业"
  },
  {
    label:"环保行业",
    value:"环保行业"
  },
  {
    label:"水利行业",
    value:"水利行业"
  },
  {
    label:"运营商",
    value:"运营商"
  },
  {
    label:"路由器厂商",
    value:"路由器厂商"
  },
  {
    label:"其它行业",
    value:"其它行业"
  },
]

export const beforeRouteNameMap=new Map([
  [
    '/speedtest-sdk',
    '网络测速SDK',
  ],
  [
    '/plugin',
    '网络测速插件',
  ],
  [
    '/cli',
    '命令行测速CLI',
  ],
  [
    '/realtime-sdk',
    '实时网速监测SDK'
  ],
  [
    '/web-open-speed-sdk',
    '网页打开速度SDK'
  ],
  [
    '/video-sdk',
    '视频测试SDK'
  ],
  [
    '/game-sdk',
    '游戏测速SDK'
  ],
  [
    '/combo-sdk',
    '综合测速SDK'
  ],
  [
    '/whole-home-wifi-sdk',
    '全屋Wi-Fi检测SDK'
  ],
  [
    '/wifi-analysis-sdk',
    'Wi-Fi分析SDK'
  ],
  [
    '/appmalf-sdk',
    '异常诊断SDK'
  ],
  [
    '/mobile-network-sdk',
    '移动网络检测SDK'
  ],
  [
    '/network-equipment',
    '网络设备测速'
  ],
  [
    '/intranet',
    '内网测速'
  ],
  [
    '/quality-monitoring',
    '网络质量监测'
  ],
  [
    '/high-bandwidth',
    '大带宽检测'
  ],
  [
    '/speedtest-deployment',
    '测速系统私有化部署'
  ],
  [
    '/nodes',
    '添加测速点'
  ],
  [
    '/custom',
    '定制开发'
  ],
  [
    '/data',
    '数据服务'
  ],
  [
    '/consulting',
    '业务咨询'
  ],
  ['/satisfaction-improvement','用户满意度提升'],
  ['/quality-monitoring','网络质量监测系统'],
  ['/edge-security-acceleration','边缘安全加速'],
  ['/wwzs/enterprise','企业用户开通'],
  ['/smpro','企业用户开通'],
  ['/testing-services','委托测试']
])

export const jobList=[
  {
    label:"产品",
    value:"产品"
  },
  {
    label:"运营",
    value:"运营"
  },
  {
    label:"市场",
    value:"市场"
  },
  {
    label:"数据",
    value:"数据"
  },
  {
    label:"技术",
    value:"技术"
  },
  {
    label:"其他",
    value:"其他"
  },
]


export const interestProductList= [
  {
    label: '网维助手', key: 'smpro', value: 'smpro', itemListShow: true,
    children: [
      {
        label: '网维助手',
        value: '网维助手',
      },
      {
        label: '更多工具',
        value: '更多工具',
        children: [
          {label: '网优宝', value: '网优宝',},
          {label: '万能测速',value: '万能测速', },
          {label: 'Wi-Fi助手',value: 'Wi-Fi助手', },
          {label: 'Wi-Fi全屋通',value: 'Wi-Fi全屋通',},
          {label: '抓包帮手',value: '抓包帮手', },
          {label: 'Wi-Fi走测', value: 'Wi-Fi走测',},
        ]
      }
    ]
  },
  {
    label: 'SDK', value: 'SDK',
    children: [
      {
        label: '网络速度与质量',
        value: '网络速度与质量',
        children: [
          {
            label: '网络测速SDK',
            value: '网络测速SDK',
          },
          {label: '网络测速插件',  value: '网络测速插件',},
          {label: '命令行测速CLI',  value: '命令行测速CLI',},
          {
            label: '实时网速监测SDK',
            value: '实时网速监测SDK',
          }
        ]
      },
      {
        label: '用户体验测试',
        value: '用户体验测试',
        children: [
          {
            label: '网页打开速度SDK',
            value: '网页打开速度SDK',
          },
          {
            label: '视频测试SDK',
            value: '视频测试SDK',
          },
          {
            label: '游戏测速SDK',
            value: '游戏测速SDK',
          },
          {
            label: '综合测速SDK',
            value: '综合测速SDK',
          },
        ]
      },
      {
        label: '场景化网络测试',
        value: '场景化网络测试',
        children: [
          {
            label: '全屋Wi-Fi检测SDK',
            value: '全屋Wi-Fi检测SDK',
          },
          {
            label: 'Wi-Fi分析SDK',
            value: 'Wi-Fi分析SDK',
          },
          {
            label: '异常诊断SDK',
            value: '异常诊断SDK',
          },
        ]
      },
      {
        label: '专项测试',
        value: '专项测试',
        children: [
          {
            label: '移动网络检测SDK',
            value: '移动网络检测SDK',
          }
        ]
      }
    ]
  },
  {
    label: '解决方案', value: '解决方案',
    children: [
      {
        label: '行业解决方案',
        value: '行业解决方案',
        children: [
          {
            label: '网络质量监测系统',
            value: '网络质量监测系统',
          },
          {
            label: '用户满意度提升',
            value: '用户满意度提升',
          },
          {
            label: '网络设备测速',
            value: '网络设备测速',
          },
          {label: '内网测速',value: '内网测速', },
          {
            label: '网络质量监测',
            value: '网络质量监测',
          },
          {
            label: '大带宽检测',
            value: '大带宽检测',
          },
          {
            label: '测速系统私有化部署',
            value: '测速系统私有化部署',
          }
        ]
      },
      {
        label: '添加测速点',
        value: '添加测速点',
      }
    ]
  },
  {label: '定制开发', value: '定制开发'},
  {label: '数据服务',  value: '数据服务'},
  {label: '业务咨询', value: '业务咨询'},
]

